import { Button, ButtonProps } from '@pankod/refine-antd'
import React, { useState } from 'react'

const ButtonAsync = <T,>(
  props: ButtonProps & { onClick?: () => Promise<T> },
) => {
  const [loading, setLoading] = useState(false)
  const onClick = async (fn?: () => Promise<T>) => {
    try {
      setLoading(true)
      await fn?.()
    } finally {
      setLoading(false)
    }
  }
  return (
    <Button
      {...props}
      loading={loading}
      onClick={async () => await onClick(props.onClick)}
    />
  )
}

export default ButtonAsync
